function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// doesnt make footer sticky, but forces to bottom
// rename
// https://css-tricks.com/snippets/css/sticky-footer/
// TODO
// add a not-wrap div (header/nav height throwing this off)
var StickyFooter = /*#__PURE__*/function () {
  function StickyFooter() {
    var footerID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'sticky-footer';
    var mainID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'main';
    _classCallCheck(this, StickyFooter);
    this.stickyFooterEl = document.getElementById(footerID);
    if (!this.stickyFooterEl) return false;
    this.mainEl = document.getElementById(mainID);
    this.embedID = 'sticky-footer-styles';
    this.embedEl = this.generateEmbedStyleEl();

    // or document.getElementsByTagName('head')[0].appendChild(this.embedEl)
    document.head.appendChild(this.embedEl);
    this.updateEmbedStyles();
  }
  return _createClass(StickyFooter, [{
    key: "bindEventHandlers",
    value: function bindEventHandlers() {
      // on load
      // on resize
    }
  }, {
    key: "generateEmbedStyleEl",
    value: function generateEmbedStyleEl() {
      var styleEl = document.createElement('style');
      styleEl.type = 'text/css';
      styleEl.id = this.embedID;
      return styleEl;
    }
  }, {
    key: "generateStylesNode",
    value: function generateStylesNode() {
      var stickyFooterHeight = this.stickyFooterEl.clientHeight;
      var cssText = "\n\t\t\t#".concat(this.mainEl.id, " {\n\t\t\t\tmin-height: 100%;\n\t\t\t\tmargin-bottom: -").concat(stickyFooterHeight, "px;\n\t\t\t}\n\t\t\t#").concat(this.mainEl.id, "::after {\n\t\t\t\tcontent: \"\";\n\t\t\t\tdisplay: block;\n\t\t\t\theight: ").concat(stickyFooterHeight, "px;\n\t\t\t}\n\t\t");
      console.dir(this.mainEl);
      console.dir(this.stickyFooterEl);
      return document.createTextNode(cssText);
    }
  }, {
    key: "updateEmbedStyles",
    value: function updateEmbedStyles() {
      console.dir(this.embedEl);
      this.embedEl.innerText = "";
      this.embedEl.appendChild(this.generateStylesNode());
    }
  }]);
}();
export { StickyFooter as default };